"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Telegraph Public API
 * Public API offering access to Telegraph data
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: bookingsupport@telegraph.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReplayRequestToJSON = exports.ReplayRequestFromJSONTyped = exports.ReplayRequestFromJSON = exports.instanceOfReplayRequest = exports.ReplayRequestStepEnum = void 0;
var ReplayRequestSearch_1 = require("./ReplayRequestSearch");
var Waybill_1 = require("./Waybill");
/**
 * @export
 */
exports.ReplayRequestStepEnum = {
    UNSPECIFIED: 'STEP_UNSPECIFIED',
    ORIGINAL_REQUEST: 'STEP_ORIGINAL_REQUEST',
    FILE_DROP: 'STEP_FILE_DROP',
    UF_ORIGINAL_REQUEST: 'STEP_UF_ORIGINAL_REQUEST',
    _824_ADVICE: 'STEP_824_ADVICE'
};
/**
 * Check if a given object implements the ReplayRequest interface.
 */
function instanceOfReplayRequest(value) {
    return true;
}
exports.instanceOfReplayRequest = instanceOfReplayRequest;
function ReplayRequestFromJSON(json) {
    return ReplayRequestFromJSONTyped(json, false);
}
exports.ReplayRequestFromJSON = ReplayRequestFromJSON;
function ReplayRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'search': json['search'] == null ? undefined : (0, ReplayRequestSearch_1.ReplayRequestSearchFromJSON)(json['search']),
        'step': json['step'] == null ? undefined : json['step'],
        'data': json['data'] == null ? undefined : json['data'],
        'tender': json['tender'] == null ? undefined : (0, Waybill_1.WaybillFromJSON)(json['tender']),
    };
}
exports.ReplayRequestFromJSONTyped = ReplayRequestFromJSONTyped;
function ReplayRequestToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'search': (0, ReplayRequestSearch_1.ReplayRequestSearchToJSON)(value['search']),
        'step': value['step'],
        'data': value['data'],
        'tender': (0, Waybill_1.WaybillToJSON)(value['tender']),
    };
}
exports.ReplayRequestToJSON = ReplayRequestToJSON;
